import styled, {css} from 'styled-components';

import {NewSelectField as BaseSelectField, NewRadioField, mixins} from '@edna/components';
import {Icon as BaseIcon} from '@edna/components/primitives';

import {InlineLink} from 'src/components/primitives';

export const SelectField = styled(BaseSelectField)`
  width: 100%;
  max-width: 484px;
`;

export const Link = styled(InlineLink)`
  color: ${({theme}) => theme.palette.grey900};
`;

export const Icon = styled(BaseIcon)`
  margin-bottom: ${({theme}) => theme.spacing.s1};
`;

export const TariffWrapper = styled.div<{isActive?: boolean; hasPointer?: boolean}>`
  ${mixins.stack({size: '2'})};
  width: 100%;

  ${({theme, hasPointer}) => css`
    padding: ${theme.spacing.s5} ${theme.spacing.s6};
    border: 1px solid ${theme.palette.grey100};
    border-radius: ${theme.borderRadius.br2};
    transition: all ${theme.animation.duration / 2}ms;

    &:hover {
      border-color: ${theme.palette.green400};
      cursor: ${hasPointer ? 'pointer' : 'default'};
    }
  `};

  ${({theme, isActive}) =>
    isActive &&
    css`
      border-color: ${theme.palette.green400};
    `};
`;

export const TariffsList = styled.div<{count: number}>`
  ${mixins.stack({size: '2', direction: 'ROW', align: 'stretch'})};
  flex-wrap: wrap;
  width: 100%;

  ${({theme, count}) => {
    const columns = Math.min(3, count);

    return css`
      gap: ${theme.spacing.s5};

      & > div {
        width: calc((100% - ${theme.spacing.s5} * ${columns - 1}) / ${columns});
        min-width: 316px;
        max-width: 502px;
      }
    `;
  }};
`;

export const RadioField = styled(NewRadioField)`
  position: relative;
  top: 4px;
`;

export const TariffTitle = styled.div`
  ${mixins.stack({size: '2', direction: 'ROW'})};
  ${mixins.f6};

  font-weight: 500;
  margin-bottom: ${({theme}) => theme.spacing.s2};
  overflow-wrap: anywhere;
`;
